<div class="grid" [ngClass]="{'collapsable': isCollapsable, 'expanded': isOpen, 'collapsed': !isOpen, 'no-border-mobile': !border}">
    <ng-content></ng-content>
</div>